<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}

</script>

<style>
  /*路由过渡动画*/
  .v-enter {
    opacity: 0;
    transform: translateY(30px);
  }
  .v-enter-to {
    opacity: 1;
  }
  .v-enter-active {
    transition: .3s;
  }
  .v-leave {
    opacity: 1;
  }
  .v-leave-to {
    transform: translateY(-30px);
    opacity: 0;
  }
  .v-leave-active {
    transition: .3s;
  }
  /*过渡动画结束*/
  /*操作*/
  .operation{
    margin: .1rem .7rem;
  }
    /*查看更多*/
  .view-more{
    text-align: center;
  }
  h4{
    margin-top: 0;
    /*margin-bottom: 10px;*/
  }
  p{
    margin: 0;
  }
  /* 标题 */
  .caption {
    text-align: center;
    font-size: 30px;
    color: #5a5a5a;
  }
  .headline {
    font-size: 50px;
    color: #dc831d;
    /*color: blue;*/
    font-weight: 600;
  }
  .product-display{
    font-size: 20px;
    margin: 20px 200px;
  }
  .product-display img {
    display: block;
    margin: auto;
    width: 80%;
  }
  .product-display p{
    margin-bottom: 10px;
  }

  .imgName{
    text-align: center;
    margin-bottom: .2rem;
  }
  .title{
    text-align: center;
    font-size: 20px;
    color: #000;
    font-weight: 600;
    margin-top: .2rem;
  }
  /*字体*/
  .product-display div p:nth-child(2){
    font-size: 22px;
    color: #333;
  }
  .product-display div p:nth-child(3){
    font-size: 14px;
    color: #b0b0b0;
    margin: 0.2rem auto 0;
    text-align: left;
    padding: 0 10px;
    display: -webkit-box;
    /*-webkit-box-orient: vertical;*/
    /*-webkit-line-clamp: 3;*/
    overflow: hidden;
  }
  /* 做浮动 */
  .left{
    float: left;
  }
  /* ul标签 */
  ul{
    list-style-type: none;
    padding: 0;
  }
  /* 模块背景 */
  .backdrop {
    background-repeat:repeat;
    background-size: 100%;
    background-position:0 -1rem;
    transition:  0.5s ;
    padding: 50px 0;
  }
  @media screen and (max-width: 1024px) {
    .product-display{
      font-size: 14px;
      margin: .3rem 1rem ;
    }
    .title{
      font-size: 18px;
      font-weight: 700;
      margin-top: .2rem;
    }
  }
  @media screen and (max-width:768px){
    .caption {
      font-size: 1rem;
    }
    .headline {
      font-size: 1.5rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue